export default "__VITE_ASSET__Bfu954LU__"